import { Plus } from "lucide-react";
import { useTranslate, type Identifier } from "ra-core";
import { Link, useLocation } from "react-router";
import { Button } from "@/components/ui/button";

import type { DealCreatePrefill } from "./dealCreatePrefill";

/**
 * Opens the opportunity form prefilled with a company (and a contact), then
 * comes back to the current page once the opportunity is saved.
 */
export const CreateDealButton = ({
  companyId,
  contactId,
}: {
  companyId?: Identifier | null;
  contactId?: Identifier;
}) => {
  const translate = useTranslate();
  const location = useLocation();
  const prefill: DealCreatePrefill = {
    company_id: companyId ?? undefined,
    contact_ids: contactId != null ? [contactId] : [],
    from: location.pathname,
  };
  return (
    <Button variant="outline" size="sm" asChild>
      <Link to="/deals/create" state={prefill}>
        <Plus />
        {translate("resources.deals.action.new")}
      </Link>
    </Button>
  );
};
